
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

// export interface FetchParams {
//   searchTerm: string;
//   courtSearch: string;
//   partySearch: string;
//   selectedStatus: string;
//   selectedDate: string;
//   currentPage: number;
//   itemsPerPage: number;
// }

// NetworkService.ts
export interface FetchParams {
  searchTerm?: string;
  courtSearch?: string;
  partySearch?: string;
  selectedStatus?: string;
  selectedDate?: string;
  currentPage: number;
  itemsPerPage: number;
}


// Helper to construct authorization headers with your stored JWT token
export const getHeaders = (): Record<string, string> => {
  const token = localStorage.getItem('access_token') || localStorage.getItem('access_token');
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
  };
};

// Helper to construct full static file URLs
export const formatSignatureUrl = (imagePath: string | null): string => {
  if (!imagePath) return '';
  
  // If it's already a full HTTP URL or Base64 string, keep it as-is
  if (imagePath.startsWith('http') || imagePath.startsWith('data:')) {
    return imagePath;
  }
  
  // Ensure leading slash and prepend backend host (http://localhost:3000)
  const cleanPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  return `${API_BASE_URL}${cleanPath}`;
};